module.exports = __webpack_public_path__ + "static/img/rules-footer.a8c8954.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rulesimg/rules-footer.png
// module id = +s/D
// module chunks = 1